/**
 * Extrae el mensaje de error de una respuesta Axios con fallback progresivo:
 *  1. error.response.data.errors   — ASP.NET Core ProblemDetails (validación)
 *  2. error.response.data.title    — ASP.NET Core ProblemDetails (título)
 *  3. error.response.data.mensaje  — campo estándar del backend
 *  4. error.response.data.message  — variante en inglés
 *  5. error.response.data          — string plano
 *  6. "No se pudo conectar…"       — sin respuesta del servidor (error.request)
 *  7. error.message                — error de JS / red
 *  8. fallback                     — texto genérico configurable
 */
export const getApiError = (
  error,
  fallback = "Ocurrió un error inesperado. Intenta de nuevo."
) => {
  const data = error?.response?.data;

  if (data) {
    // ASP.NET Core ProblemDetails: { type, title, status, traceId, errors }
    if (data.errors && typeof data.errors === "object") {
      const first = Object.values(data.errors).flat()[0];
      if (first) return String(first);
    }
    if (typeof data.title === "string" && data.title) return data.title;
    if (typeof data.mensaje === "string" && data.mensaje) return data.mensaje;
    if (typeof data.message === "string" && data.message) return data.message;
    if (typeof data === "string" && data) return data;
  }

  if (error?.request) return "No se pudo conectar con el servidor.";
  return error?.message || fallback;
};
